/** Fallback MediaRecorder timeslice when init does not return chunkDurationMs. */
export const DEFAULT_CHUNK_DURATION_MS = 15 * 1000

/** Live chunk duration returned by recording/init (MediaRecorder timeslice). */
export const INIT_CHUNK_DURATION_MS = 30 * 1000

/**
 * Bound wait after MediaRecorder.stop() for a late dataavailable (Safari).
 * Keeps flush from racing ahead of the last blob enqueue.
 */
export const RECORDER_STOP_DATA_WAIT_MS = 2000

/**
 * Grace after INTERVIEW_DONE / RESULT_COMPLETED during which wrap-up APIs
 * (part-url mint, session-log append) may still succeed. Covers an in-flight
 * chunk, the stop() flush chunk, and one extra timeslice of upload slack.
 * Sized to the live init timeslice (30s), not the 15s fallback default.
 */
export const COMPLETED_WRAPUP_GRACE_MS = INIT_CHUNK_DURATION_MS * 3

/**
 * Frame rate of the interview recording. The canvas compositor draws and captures at this rate, and the camera and
 * screen share ask for it too (`ideal`, so devices that can't still work) — so every source feeds the recording at a
 * steady 30fps instead of whatever the device defaults to.
 */
export const RECORDING_FRAME_RATE = 30

/**
 * Video bitrate cap for the interview recording. Without it Chrome encodes at ~2.5 Mbps, and each 30s chunk upload
 * fills a typical 1–3 Mbps home uplink, starving the live WebRTC interview audio (INT-1043). 800 kbps keeps a
 * 1280-wide screen share legible.
 */
export const RECORDER_VIDEO_BITS_PER_SECOND = 800_000
